<template>
  <CustomSelect
    class="w-100"
    inputId="reportTypePicker"
    inputLabel="بازه‌ی گزارش"
    v-model="selectedReportType"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="reportTypesOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedReportType: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedReportType) {
      this.selectedReportType = this.defaultSelectedReportType;
    }
  },
  data() {
    return {
      selectedReportType: 1,
      reportTypesOptions: [
        {
          text: "هفتگی",
          value: 1,
        },
        {
          text: "ماهانه",
          value: 2,
        },
        {
          text: "سالانه",
          value: 3,
        },
        {
          text: "روزانه",
          value: 4,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
